import { Grid, Box, Divider } from '@material-ui/core'

import { Page, Container } from 'components'

import {
  Menu,
  OnPage,
  ButtonBaseComponent,
  Title,
  Paragraph,
} from '../../components'

import Withdraws from 'images/documentation/platform/withdraws.png'

import { routes } from 'Routes'

const WithDrawsPlatform = () => {
  const onPage = [['#d-saques', 'Saques']]
  // const Code = ({ children }) => {
  //   return (
  //     <span
  //       style={{
  //         backgroundColor: '#e2f4f9',
  //         border: '1px solid #63bbdb',
  //         textTransform: 'lowercase',
  //         padding: '1px',
  //         fontSize: '12px',
  //         fontWeight: 400,
  //         width: 'auto',
  //         borderRadius: '4px',
  //       }}
  //     >
  //       {children}
  //     </span>
  //   )
  // }

  return (
    <Page title="Saques">
      <Container maxWidth="md">
        <Box style={{ marginBottom: '40px' }}>
          <Grid container spacing={8}>
            <Grid item xs={12} sm={12} md={12} lg={2}>
              <Menu />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={8}>
              <Box style={{ marginBottom: '40px' }}>
                <Title variant="h5" id="d-saques" subtitle="Plataforma">
                  Saques
                </Title>
                <Paragraph>
                  O saque é o processo de retirada de dinheiro de uma conta
                  bancária ou plataforma financeira, transferindo-o para outro
                  destino, como uma conta principal, uma carteira digital ou
                  diretamente em espécie. Ele pode ser realizado de diversas
                  formas, como por meio de caixas eletrônicos, transferências
                  bancárias ou plataformas digitais. <br />
                  <br />
                  Normalmente, ao realizar um saque, é necessário seguir algumas
                  etapas:
                  <br />
                  <br />
                  <Box ml={10}>
                    <ul>
                      <li>
                        <b>Verificação da conta:</b> Certificar-se de que a
                        conta utilizada está ativa e com saldo suficiente.
                      </li>
                      <li>
                        <b>Escolha do valor:</b> Inserir o valor desejado,
                        respeitando limites impostos pela instituição.
                      </li>
                      <li>
                        <b>Confirmação:</b> Confirmar a operação, que pode
                        incluir autenticação adicional, como senha ou biometria.
                      </li>
                      <li>
                        <b>Acompanhamento:</b> Após o saque, é comum que a
                        instituição disponibilize um status ou comprovante para
                        acompanhamento.
                      </li>
                    </ul>
                  </Box>
                  <br />
                  <br />
                  <img
                    src={Withdraws}
                    width="100%"
                    style={{ border: '1px solid silver', borderRadius: '20px' }}
                    alt="Ilustração do processo de saque"
                  />
                </Paragraph>
              </Box>
              <Divider />
              <Grid container>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <ButtonBaseComponent
                    nextName="Bancos"
                    previousName="Planos"
                    previousRoute={routes.documentation.plansPlatform}
                    nextRoute={routes.documentation.banksPlataform}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={2}>
              <OnPage page={onPage} />
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Page>
  )
}

export default WithDrawsPlatform
